// extracted by mini-css-extract-plugin
export var productImage = "_z8-0";